/* tslint:disable */

declare var Object: any;
export interface ExportInterface {
  "id"?: number;
}

export class Export implements ExportInterface {
  "id": number;
  constructor(data?: ExportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Export`.
   */
  public static getModelName() {
    return "Export";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Export for dynamic purposes.
  **/
  public static factory(data: ExportInterface): Export{
    return new Export(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Export',
      plural: 'Exports',
      path: 'Exports',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
